import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import IdentityInfo from "./identityInfo";
import TabPanelCmp from "../../../components/tabPanel/tabPanelCmp";
import PlaceInfo from "./placeInfo";
import IncomeInfo from "./incomeInfo";
import InstallmentInfo from "./installmentInfo";
import ContractInfo from "./contractInfo";
import FactorInfo from "./factorInfo";
import FurtherInfo from "./furtherInfo";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CancellationReasons from "./cancelReason";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import SellerDocument from "./sellerDocument";
import GuarantorInfo from "./guarantorInfo";
import GuarantorDocuments from "./guarantorDocuments";
import VehicleDocuments from "./vehicleDocuments";
import VehicleExpert from "./vehicleExpert";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function _TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabsPanel(props: any) {
  const jsonFile = useSelector((state: any) => state.style);
  const tabs = [
    {
      id: 0,
      key: "Identity",
      title: " مدارک هویتی خریدار",
      icon: <AssignmentIndOutlinedIcon />,
      child: <IdentityInfo data={props.panelTabs.identityDocuments} />,
    },
    {
      id: 1,
      key: "Residential",
      title: " مدارک سکونتی خریدار ",
      icon: <HomeOutlinedIcon />,
      child: <PlaceInfo data={props.panelTabs.address} />,
    },
    {
      id: 2,
      key: "Incomes",
      title: " مدارک درآمدی خریدار ",
      icon: <BusinessCenterOutlinedIcon />,
      child: <IncomeInfo data={props.panelTabs.incomes} />,
    },
    {
      id: 10,
      key: "Vehicle",
      title: "مدارک خودرو",
      icon: <DirectionsCarFilledOutlinedIcon />,
      child: (
        <VehicleDocuments data={props.panelTabs.vehicle} showDocuments={true} />
      ),
    },
    {
      id: 11,
      key: "VehicleExpert",
      title: "کارشناسی خودرو",
      icon: <img src="images/manageAccounts.svg" />,
      child: <VehicleExpert data={props.panelTabs.vehicleExpert} />,
    },
    {
      id: 12,
      key: "Seller",
      title: "مدارک فروشنده",
      icon: <img src="images/SellerDoc.svg" />,
      child: <SellerDocument data={props.panelTabs.seller} />,
    },
    {
      id: 13,
      key: "Guarantor",
      title: "مدارک ضامنین",
      icon: <img src="images/guarantor.svg" />,
      child: <GuarantorDocuments data={props.panelTabs.guarantors} />,
    },
    {
      id: 3,
      key: "Guarantee",
      title: " اطلاعات ضمانتی خریدار",
      icon: <img src="images/warranty.svg" />,
      child: <GuarantorInfo data={props.panelTabs.guarenteeCheque} />,
    },

    {
      id: 4,
      key: "Installment",
      title: "  اقساط",
      icon: <img src="images/calendar.svg" />,
      child: <InstallmentInfo data={props.panelTabs.installmentCheques} />,
    },
    {
      id: 5,
      key: "Contract",
      title: " قرارداد ",
      icon: <img src="images/contract.svg" />,
      child: <ContractInfo data={props.panelTabs.contract} />,
    },
    {
      id: 6,
      key: "Factor",
      title: "  فاکتور  ",
      icon: <ReceiptLongOutlinedIcon />,
      child: <FactorInfo data={props.panelTabs.factor} />,
    },
    {
      id: 7,
      key: "Other",
      title: " اطلاعات تکمیلی",
      icon: <img src="images/otherTabs.svg" />,
      child: <FurtherInfo data={props.panelTabs.otherDocuments} />,
    },
    {
      id: 9,
      key: "LoanCancellationBySupplier",
      title: " علل لغو درخواست",
      icon: <CancelOutlinedIcon />,
      child: (
        <CancellationReasons
          data={props.panelTabs.supplierCancellationReasons}
        />
      ),
    },
  ];
  let findedActiveTabs = [] as any;
  let count = 0;
  tabs?.map((item: any) => {
    let findedItem = props.panelTabs.tabKeys?.find((z: any) => z == item.key);

    if (findedItem != undefined) {
      item.id = count;
      count++;
      findedActiveTabs.push(item);
    }
  });
  const panelTabs = tabs.filter((v) =>
    props.panelTabs.tabKeys?.includes(v.key)
  );
  return <TabPanelCmp tab={findedActiveTabs} colorTab={jsonFile?.mainColor} />;
}
